import { render, staticRenderFns } from "./VerificationButton.vue?vue&type=template&id=71e55779&scoped=true&"
import script from "./VerificationButton.vue?vue&type=script&lang=js&"
export * from "./VerificationButton.vue?vue&type=script&lang=js&"
import style0 from "./VerificationButton.vue?vue&type=style&index=0&id=71e55779&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e55779",
  null
  
)

export default component.exports